import { useQuery } from '@tanstack/react-query';
import { RealmsService } from '../services/realms';

export const useRealms = () => {
  return useQuery({
    queryKey: ['realms'],
    queryFn: () => RealmsService.getRealms(),
    staleTime: 10 * 60 * 1000, // 10 minutes - realms don't change often
  });
};
